import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';

const api = new Api('attire_groups/:id');

function* loadData({ payload }) {
  try {
    const { id } = payload;

    const result = yield call(sendRequest, api.load, { id }, notifications.REQUEST_ERROR);

    if (result) {
      const { data } = result;

      yield put(actions.loadDataSuccess({ data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
